<template>
  <ValidationObserver ref="step0" v-slot:="{ handleSubmit }" tag="div">
    <form class="needs-validation" @submit.prevent="handleSubmit(setStatus)">
      <div class="flex flex-column">
        <div class="col-12">
          <validation-select
            v-model="statusForm.state"
            rules="required"
            :options="statusOptions"
            placeholder="وضعیت"
            option-value-key="id"
            option-text-key="name"
            validation-field-name="وضعیت"
            label="وضعیت"
          ></validation-select>
        </div>
        <div class="col-12">
          <validation-text-area
            v-if="statusForm.state && statusForm.state.id == 3"
            v-model="statusForm.reject_reason"
            rules="required"
            placeholder="علیت رد درخواست"
            validation-field-name="علت رد درخواست"
            label="علت رد درخواست"
          ></validation-text-area>
        </div>
        <div class="col-12">
          <button
            class="btn btn-success mt-4"
            style="float: left"
            type="submit"
          >
            ارسال درخواست
          </button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
export default {
  props: {
    recordId: Number,
  },
  data() {
    return {
      statusOptions: [
        {
          id: 1,
          name: 'ارسال برای پرداخت',
        },
        {
          id: 2,
          name: 'پرداخت شده',
        },
        {
          id: 3,
          name: 'رد شده',
        },
      ],
      statusForm: {
        state: null,
        reject_reason: null,
      },
    }
  },
  methods: {
    setStatus() {
      this.$axios
        .put('transfer-requests/' + this.recordId, {
          state: this.statusForm.state.id,
          reject_reason: this.statusForm.reject_reason,
        })
        .then(() => {
          this.$swal.fire(
            'موفق!',
            `وضعیت درخواست با موفقیت تغییر یافت`,
            'success'
          )
        })
    },
  },
}
</script>

<style></style>
